import React, { useState, useEffect } from "react";
import "./Timeline.css";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";
import { Fade, Bounce } from "react-reveal";
import ChurchHistoryTimeline from "./ChurchHistoryTimeline";

const TimelineSection = ({ theme }) => {
  const { language } = useLanguage();
  const [activePhase, setActivePhase] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const timelinePhases =
    language === "amharic"
      ? [
          {
            title: "ቅድመ ቤተ ክርስቲያን",
            year: "2001-2018",
            description:
              "ቤተ ክርስቲያናችን አሁን ካልችበት ቦታ ከመድረሷ በፊት በሀገረ ኒውዚላንድ ይኖሩ የነበሩ ኦርቶዶክሳዊያን ምእመናን ቅድስት ኦርቶዶክሳዊት ሃይማኖታቸውን ለመጠበቅና መንፈሳዊ ህይወታቸውን ለማሻሻል በግለሰብ ቤት እና የተለያዩ አዳራሾችን በመከራየት በ2001 እኤአ ማህበር አቋቁመው እርስ በርሳቸው እየተማማሩ፣ በጋራ ይጸልዩ ነበር።",
            phase: 0,
          },
          {
            title: "የቤተክርስቲያኗ መቋቋም",
            year: "2018",
            description:
              "ቋሚ የሆነ አባት እንዲኖረ ከነበረው ጽኑ ፍላጎት የተነሳ ከ 3 ዓመት ድካም እና ውጣ ውረድ በኋላ እግዚአብሄር ፈቃዱ ሆኖ ሕዳር 28 2018 እ ኤ አ አሁን እያገለገሉ ያሉትን አባት መልአከ ጽዮን ቆሞስ አባ ተክለ ስላሴ ሊመጡ ችለዋል።",
            phase: 1,
          },
          {
            title: "የወድፊት እቅዶች",
            year: "2023+",
            description:
              "በአሁኑ ጊዜ አገልግሎት እየተካሄደ ያለው ቤተ ክርስቲያን በመከራየት ቢሆንም ቤተ ክርስቲያናችን በመስከረም 27፣ 2023 እ ኤ አ 5.2 ሄክታር ስፋት ያለው ውብ የሆነ ቦታ ገዝታ ህንጻ ቤተክርስቲያን ለመገንባት ፈቃድ አግኝታ በመንቀሳቀስ ላይ ትገኛለች።",
            phase: 2,
          },
        ]
      : [
          {
            title: "Pre Church",
            year: "2001-2016",
            description:
              "Before our church reached its current location, Orthodox believers living in New Zealand established an association in 2001, renting individual homes and various halls to preserve their Holy Orthodox faith and improve their spiritual lives, where they would learn from each other and pray together.",
            phase: 0,
          },
          {
            title: "Establishment of the Church",
            year: "2018",
            description:
              "Due to the strong desire to have a permanent father, after 3 years of hard work and ups and downs, God's will be fulfilled on November 28, 2018, and Father Melake Tsion Komos Abba Tekle Selassie, who is currently serving, was able to come.",
            phase: 1,
          },
          {
            title: "Future Plan",
            year: "2023+",
            description:
              "Although the church where services are currently being held is rented, our church purchased a beautiful 5.2-hectare plot of land on September 27, 2023, and obtained permission to build a church building. We are currently raising funds to build a church, community halls, accommodation units, holy water house and baptism unit.",
            phase: 2,
          },
        ];

  return (
    <div className="timeline-container">
      {/* New Interactive Church History Timeline */}
      <Fade bottom duration={1000}>
        <ChurchHistoryTimeline
          text={getTranslation(language, "about_church_intro")}
          language={language}
        />
      </Fade>

      {/* Mission statement */}
      <Fade bottom duration={1200}>
        <div className="timeline-mission">
          <p
            className="subTitle about-text"
            style={{ color: theme.secondaryText }}
          >
            {getTranslation(language, "about_church_mission")}
          </p>
        </div>
      </Fade>
    </div>
  );
};

export default TimelineSection;
